module.exports = __webpack_public_path__ + "static/media/stories-section-img.96cb1558.png";